import React from "react";
import { makeStyles } from "@material-ui/styles";
import Spinner from "react-spinkit";

import { colors, fonttypes, fontSizes } from "../Css";
/**
 * @param {String} title: the title of the button
 * @param {Boolean} isLoading: a boolean value if the action perform is in a loading state
 * @param {String} type: select either large or normal
 * @param {Function} onClick: the callback function to submit the form
 */
const AppButton = ({ title, isLoading, onClick, type, styles }) => {
  const classes = useStyles();
  const classnames =
    type === "large"
      ? `${classes.root} ${classes.largeButton}`
      : `${classes.root} ${classes.normalButton}`;
  return (
    <button type={type} className={classnames} onClick={onClick} style={{ ...styles }}>
      {isLoading ? (
        <Spinner name="double-bounce" color="white" fadeIn="none" />
      ) : (
        title
      )}
    </button>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: colors.darkerPrimary,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: colors.white,
    border: "none",
    borderRadius: 4,
    fontFamily: fonttypes.sg_medium,
    boxShadow: `0px 6px 12px rgba(0, 0, 0, 0.0976016)`,
  },
  largeButton: {
    width: 348,
    height: 60,
    fontSize: fontSizes.lg,
  },
  normalButton: {
    padding: `8px 16px`,
    fontSize: fontSizes.sm,
    marginLeft: 0,
  },
});

export default AppButton;
